import { z } from "zod";
import type { StandardSchemaV1 } from "@tanstack/react-form";

import {
	createChangePasswordSchemaBase,
	type ChangePasswordFormValuesBase,
} from "@/features/auth/changePasswordSchema";
import type { PasswordStrengthValidation } from "@/features/auth/passwordStrengthValidation";

export interface ChangePasswordFormValues extends ChangePasswordFormValuesBase {
	current: string;
}

export function createChangePasswordSchema(
	hasConnectedMobileDevices: boolean,
	passwordStrengthValidation?: PasswordStrengthValidation,
): StandardSchemaV1<ChangePasswordFormValues> {
	return z
		.object({
			current: z.string().min(1, { error: messages["validator.messages.required"] }),
		})
		.and(
			createChangePasswordSchemaBase(
				hasConnectedMobileDevices,
				passwordStrengthValidation,
			),
		) as StandardSchemaV1<ChangePasswordFormValues>;
}
